import { MenuProps } from 'antd';
import { TFunction } from 'i18next';

import { AppDispatch } from 'app/store';

import ApplicationsService from 'features/applications/applicationsService';
import { updateApplication } from 'features/applications/applicationsSlice';

import { notify } from 'utils/toast/createToast';

import { ClientApplicationStages } from 'constants/enums';

import { ReactComponent as Bell } from 'assets/icons/bell.svg';
import { ReactComponent as ClientSearch } from 'assets/icons/clientSearch.svg';
import { ReactComponent as Declined } from 'assets/icons/declined.svg';
import { ReactComponent as TickSquare } from 'assets/icons/tickSquare.svg';

import { TranslationKey } from '../../types/i18next';
import styles from './JobseekerApplication.module.scss';

export const stageClassNames: Record<ClientApplicationStages, string> = {
  [ClientApplicationStages.AcceptedApplicationStageClient]: styles.accepted,
  [ClientApplicationStages.ClientReviewApplicationStageClient]:
    styles.clientReview,
  [ClientApplicationStages.DeclinedApplicationStageClient]: styles.declined,
  [ClientApplicationStages.NewApplicationStageClient]: styles.new,
  [ClientApplicationStages.CompletedApplicationStageClient]: styles.completed,
  [ClientApplicationStages.HiredApplicationStageClient]: styles.hired
};

export const stageIcons: Record<
  ClientApplicationStages,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  [ClientApplicationStages.AcceptedApplicationStageClient]: TickSquare,
  [ClientApplicationStages.ClientReviewApplicationStageClient]: ClientSearch,
  [ClientApplicationStages.CompletedApplicationStageClient]: TickSquare,
  [ClientApplicationStages.DeclinedApplicationStageClient]: Declined,
  [ClientApplicationStages.NewApplicationStageClient]: Bell,
  [ClientApplicationStages.HiredApplicationStageClient]: TickSquare
};

export const disabledStageTooltips: {
  stage: ClientApplicationStages;
  text: TranslationKey;
}[] = [
  {
    stage: ClientApplicationStages.CompletedApplicationStageClient,
    text: 'stageSelector.tooltip.statusCannotBeChanged'
  },
  {
    stage: ClientApplicationStages.DeclinedApplicationStageClient,
    text: 'stageSelector.tooltip.statusCannotBeChanged'
  }
];

export const handleChangeStage =
  (
    id: string,
    dispatch: AppDispatch,
    translate: TFunction<'common', undefined>
  ): MenuProps['onClick'] =>
  async ({ key }) => {
    const stage = key as ClientApplicationStages;

    try {
      await ApplicationsService.changeApplicationStage(id, stage);
      dispatch(
        updateApplication({
          id,
          clientStage: stage
        })
      );
    } catch (error) {
      notify({
        message: translate('error.message.operationFailed'),
        description: translate('error.message.updateApplicationStage')
      });
    }
  };

export const configStyles = styles;
